<template>
    <div class="copilot-box relative mt-[60px] rounded-lg border border-grey-40 p-4">
        <!-- eslint-disable-next-line vue/html-self-closing -->
        <img
            src="../../assets/images/copilot.png"
            alt="copilot"
            class="absolute left-4 top-[-64px] h-[80px] w-[90px]"
        />
        <slot />
    </div>
</template>

<style lang="scss">
.copilot-box {
    background: url('../../assets/images/bg-copilot-box.png') no-repeat top left;
    border: 1px solid #dfe1e6;
    box-shadow: 0 0 4px 0 #0764e924, 0 4px 8px 0 #0764e914;
}
</style>
